import {VideoTypeEnum} from "../../Enums/VideoTypeEnum";
import {VideoStartOptionEnum} from "../../Enums/VideoStartOptionEnum";
import {PageComponentButtonClass, PageComponentButtonInterface} from "./PageComponentButtonInterface";

export interface VideoInterface {
	title: string,
	lead?: string,
	url: string,
	section_background_color: string,
	type: VideoTypeEnum,
	startOption: VideoStartOptionEnum
	button: PageComponentButtonInterface,
}

export class VideoComponentClass implements VideoInterface {
	title = '';
	lead = '';
	url = '';
	section_background_color = '';
	type = VideoTypeEnum.WIDE_VIDEO;
	startOption = VideoStartOptionEnum.START_AUTO;
	button = new PageComponentButtonClass();
}
